<template>
  <div v-if="problem && problem.id" class="problem-summary-section">
    <h2 class="basic-sub-title problem-sheet__section-title">
      {{ $t('message.SUMMARY') }}
    </h2>
    <div class="problem-sheet__table">
      <div class="problem-sheet__row">
        <div class="problem-sheet__cell">
          <div class="problem-sheet__cell__wrapper problem-summary-section__created">
            <div class="legend legend--bottom-margin">
              {{ $t('message.CREATED_ON') }}
            </div>
            <div>{{ $moment(problem.created).format($t('dateTimeFormat')) }}</div>
          </div>
        </div>
        <div class="problem-sheet__cell">
          <div class="problem-sheet__cell__wrapper problem-summary-section__id">
            <div class="legend legend--bottom-margin">
              {{ $t('message.IDENTIFIER') }}
            </div>
            <div>{{ problem.id }}</div>
          </div>
        </div>
      </div>
      <div class="problem-sheet__row">
        <div class="problem-sheet__cell" :class="{ 'problem-sheet__cell--user-padding': userCreator }">
          <div class="problem-sheet__cell__wrapper v-centerer problem-summary-section__creator">
            <UserThumbnail
              v-if="userCreator"
              :value="Number(userCreator.id)"
              fetch-data
              disabled
            />
            <div>
              <div class="legend legend--bottom-margin-small">
                {{ $t('message.CREATED_BY') }}
              </div>
              <div>{{ userCreator ? $t('fullNameFormat', userCreator) : problem.reportTeamName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="problem-sheet__row">
        <div
          class="problem-sheet__cell problem-sheet__cell--user-padding"
          @click="isMounted ? $refs.pbLeader.$el.click() : ''"
        >
          <div class="problem-sheet__cell__wrapper v-centerer">
            <UserThumbnail
              ref="pbLeader"
              :value="problem.leaders[0] || 0"
              fetch-data
              :disabled="disabled"
              :all-users="allUsers"
              force-value-as-array
              @input="editProblem('leaders', $event)"
            />
            <div>
              <div class="legend legend--bottom-margin-small">
                {{ $t('message.LEADER') }}
              </div>
              <div>{{ problem.leaders[0]
                ? $t('fullNameFormat', allUsers.find(({ id }) => id === problem.leaders[0]))
                : $t('message.CLICK_TO_CHANGE') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Summary section of the problem sheet.
 *
 * @vue-prop {Object} problem - Problem object
 * @vue-prop {Boolean} [disabled] - Whether the problem sheet is editable
 */
// Vuex
import { EDIT_PROBLEM } from '@/store/modules/problem/action-types';
// Inport components
import UserThumbnail from '@/components/user-thumbnail.vue';
// Import socket handling utils
import mixinSocketHandler from '@/mixins/socket-handler.vue';
import SocketMessages from '@/utils/classes/SocketMessages';


export default {

  name: 'ProblemSummarySection',

  components: {
    UserThumbnail,
  },

  mixins: [mixinSocketHandler],

  props: {
    problem: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },

  data() {
    return {
      isMounted: false,
    };
  },

  computed: {
    /** Object: User that created the problem if any */
    userCreator() {
      const history = this.$store.state.problem.history[`${this.problem.id}`] || [];
      if (this.allUsers.length && history.length) {
        const creator = history[history.length - 1].user;
        // Get the user from the last history item because the history array is sorted by DESC
        return this.allUsers.find(u => creator && u.id === creator);
      }
      return null;
    },
    /** Array: All available users in this problem sheet */
    allUsers() {
      return this.$store.getters['problem/radioUsers'](this.problem.id);
    },
  },

  mounted() {
    this.isMounted = true;
  },

  methods: {
    /** Problem field was edited */
    editProblem(field, value) {
      value = value || this.problem[field];
      const params = { id: this.problem.id, [field]: value };
      this.$store.dispatch(`problem/${EDIT_PROBLEM}`, params).then(this.sendSocketUpdate);
    },
    /** Send a socket msg to notify teams that this problem sheet can be refreshed */
    sendSocketUpdate() {
      this.sendSocketMessage({ msg: SocketMessages.CC_MSGS.PROBLEM_SHEET, id: this.problem.id, socketCompany: 1 });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.problem-summary-section {

  &__created.problem-sheet__cell__wrapper {
    min-width: 5.5rem;
    white-space: nowrap;
  }

  &__created, &__id, &__creator {
    &.problem-sheet__cell__wrapper {
      cursor: initial;
    }
  }
}
</style>
